import { LEGACY_TENANT_SLUGS } from '../api/types';

/**
 * Which store a tenant lives in — the one question behind every
 * `!LEGACY_TENANT_SLUGS.has(slug)` in the codebase.
 *
 * It decides more than a data source: legacy tenants resolve permissions from
 * the Auth0 JWT and have no row in the operational DB, so anything reading
 * `tenant.entitlements`, `tenant.config` or a self-service-only endpoint is
 * meaningless for them — the backend answers 409, not data. Surfaces that
 * depend on those must ask this first instead of rendering an error state a
 * legacy tenant can never resolve.
 */
export const isSelfServiceTenant = (slug: string | null | undefined): boolean =>
    !!slug && !LEGACY_TENANT_SLUGS.has(slug);

/** Inverse of {@link isSelfServiceTenant}; `false` when no tenant is selected. */
export const isLegacyTenant = (slug: string | null | undefined): boolean =>
    !!slug && LEGACY_TENANT_SLUGS.has(slug);
